interface IconProps {
  color?: string;
  size?: number;
  className?: string;
}

export function ArrowRightIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.4697 4.46967C11.7626 4.17678 12.2374 4.17678 12.5303 4.46967L19.5303 11.4697C19.8232 11.7626 19.8232 12.2374 19.5303 12.5303L12.5303 19.5303C12.2374 19.8232 11.7626 19.8232 11.4697 19.5303C11.1768 19.2374 11.1768 18.7626 11.4697 18.4697L17.1893 12.75H5C4.58579 12.75 4.25 12.4142 4.25 12C4.25 11.5858 4.58579 11.25 5 11.25H17.1893L11.4697 5.53033C11.1768 5.23744 11.1768 4.76256 11.4697 4.46967Z'
        fill={color}
      />
    </svg>
  );
}

export function ArrowLeftIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.5303 4.46967C12.8232 4.76256 12.8232 5.23744 12.5303 5.53033L6.81066 11.25H19C19.4142 11.25 19.75 11.5858 19.75 12C19.75 12.4142 19.4142 12.75 19 12.75H6.81066L12.5303 18.4697C12.8232 18.7626 12.8232 19.2374 12.5303 19.5303C12.2374 19.8232 11.7626 19.8232 11.4697 19.5303L4.46967 12.5303C4.17678 12.2374 4.17678 11.7626 4.46967 11.4697L11.4697 4.46967C11.7626 4.17678 12.2374 4.17678 12.5303 4.46967Z'
        fill={color}
      />
    </svg>
  );
}

export function BackIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.5303 5.46967C15.8232 5.76256 15.8232 6.23744 15.5303 6.53033L10.0607 12L15.5303 17.4697C15.8232 17.7626 15.8232 18.2374 15.5303 18.5303C15.2374 18.8232 14.7626 18.8232 14.4697 18.5303L8.46967 12.5303C8.17678 12.2374 8.17678 11.7626 8.46967 11.4697L14.4697 5.46967C14.7626 5.17678 15.2374 5.17678 15.5303 5.46967Z'
        fill={color}
      />
    </svg>
  );
}

export function ArrowDownIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 4.25C12.4142 4.25 12.75 4.58579 12.75 5V17.1893L18.4697 11.4697C18.7626 11.1768 19.2374 11.1768 19.5303 11.4697C19.8232 11.7626 19.8232 12.2374 19.5303 12.5303L12.5303 19.5303C12.2374 19.8232 11.7626 19.8232 11.4697 19.5303L4.46967 12.5303C4.17678 12.2374 4.17678 11.7626 4.46967 11.4697C4.76256 11.1768 5.23744 11.1768 5.53033 11.4697L11.25 17.1893V5C11.25 4.58579 11.5858 4.25 12 4.25Z'
        fill={color}
      />
    </svg>
  );
}

export function CartIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        d='M7.7 22.4402C8.6665 22.4402 9.45 21.6567 9.45 20.6902C9.45 19.7237 8.6665 18.9402 7.7 18.9402C6.7335 18.9402 5.95 19.7237 5.95 20.6902C5.95 21.6567 6.7335 22.4402 7.7 22.4402Z'
        fill={color}
      />
      <path
        d='M18.7 22.4402C19.6665 22.4402 20.45 21.6567 20.45 20.6902C20.45 19.7237 19.6665 18.9402 18.7 18.9402C17.7335 18.9402 16.95 19.7237 16.95 20.6902C16.95 21.6567 17.7335 22.4402 18.7 22.4402Z'
        fill={color}
      />
      <path
        d='M22.38 7.27022C22.24 7.09022 22.02 6.99022 21.8 6.99022H5.43L4.49 2.60022C4.48 2.54022 4.46 2.48022 4.43 2.42022C4.38 2.32022 4.31 2.23022 4.22 2.16022C4.14 2.09022 4.04 2.04022 3.93 2.02022C3.87 2.00022 3.8 2.00022 3.74 2.00022H1.75C1.34 1.99022 1 2.33022 1 2.74022C1 3.15022 1.34 3.49022 1.75 3.49022H3.14L4.08 7.90022C4.08 7.90022 4.08 7.92022 4.08 7.93022L5.66 15.3202C5.79 15.9402 6.14 16.5102 6.64 16.9002C7.13 17.2802 7.73 17.4902 8.33 17.4902C8.35 17.4902 8.37 17.4902 8.39 17.4902H18.17C18.79 17.4902 19.4 17.2702 19.89 16.8802C20.37 16.4902 20.72 15.9402 20.85 15.3302L22.5 7.90022C22.55 7.68022 22.5 7.45022 22.35 7.27022H22.38ZM19.41 15.0102C19.35 15.2902 19.19 15.5402 18.97 15.7202C18.75 15.9002 18.47 16.0002 18.19 16.0002H8.39C8.1 16.0202 7.81 15.9102 7.59 15.7302C7.36 15.5502 7.2 15.2902 7.14 15.0102L5.75 8.50022H20.86L19.41 15.0202V15.0102Z'
        fill={color}
      />
    </svg>
  );
}

export function ArrowUpIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.4697 4.46967C11.7626 4.17678 12.2374 4.17678 12.5303 4.46967L19.5303 11.4697C19.8232 11.7626 19.8232 12.2374 19.5303 12.5303C19.2374 12.8232 18.7626 12.8232 18.4697 12.5303L12.75 6.81066V19C12.75 19.4142 12.4142 19.75 12 19.75C11.5858 19.75 11.25 19.4142 11.25 19V6.81066L5.53033 12.5303C5.23744 12.8232 4.76256 12.8232 4.46967 12.5303C4.17678 12.2374 4.17678 11.7626 4.46967 11.4697L11.4697 4.46967Z'
        fill={color}
      />
    </svg>
  );
}

export function AwardIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.3458 12.1516C15.7536 12.0791 16.143 12.351 16.2154 12.7588L17.7315 21.291C17.774 21.542 17.7387 21.8 17.6306 22.0304C17.5224 22.2608 17.3465 22.4527 17.1263 22.5805C16.9062 22.7083 16.6522 22.7657 16.3985 22.7453C16.1513 22.7253 15.9158 22.6324 15.7218 22.4784L12.1531 19.7998C12.11 19.7678 12.0572 19.7501 12.0035 19.7501C11.9497 19.7501 11.8973 19.7675 11.8542 19.7996L8.2787 22.4777C8.0849 22.6314 7.84974 22.7241 7.60293 22.7441C7.34951 22.7646 7.09587 22.7073 6.87585 22.5799C6.65584 22.4525 6.47989 22.2611 6.37149 22.0311C6.2631 21.8011 6.22741 21.5435 6.2692 21.2927L6.27051 21.2849L7.78455 12.7589C7.85697 12.351 8.2463 12.0791 8.65413 12.1516C9.06196 12.224 9.33387 12.6133 9.26145 13.0211L7.85919 20.9178L10.9554 18.5987C11.2578 18.3728 11.626 18.2501 12.0035 18.2501C12.381 18.2501 12.7484 18.3722 13.0509 18.5982L13.0522 18.5992L16.1418 20.9181L14.7386 13.0212C14.6661 12.6134 14.938 12.224 15.3458 12.1516Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 2.75C9.10051 2.75 6.75 5.10051 6.75 8C6.75 10.8995 9.10051 13.25 12 13.25C14.8995 13.25 17.25 10.8995 17.25 8C17.25 5.10051 14.8995 2.75 12 2.75ZM5.25 8C5.25 4.27208 8.27208 1.25 12 1.25C15.7279 1.25 18.75 4.27208 18.75 8C18.75 11.7279 15.7279 14.75 12 14.75C8.27208 14.75 5.25 11.7279 5.25 8Z'
        fill={color}
      />
    </svg>
  );
}

export function CalendarIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 1.25C8.41421 1.25 8.75 1.58579 8.75 2V6C8.75 6.41421 8.41421 6.75 8 6.75C7.58579 6.75 7.25 6.41421 7.25 6V2C7.25 1.58579 7.58579 1.25 8 1.25ZM16 1.25C16.4142 1.25 16.75 1.58579 16.75 2V6C16.75 6.41421 16.4142 6.75 16 6.75C15.5858 6.75 15.25 6.41421 15.25 6V2C15.25 1.58579 15.5858 1.25 16 1.25Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5 4.75C4.30964 4.75 3.75 5.30964 3.75 6V20C3.75 20.6904 4.30964 21.25 5 21.25H19C19.6904 21.25 20.25 20.6904 20.25 20V6C20.25 5.30964 19.6904 4.75 19 4.75H5ZM2.25 6C2.25 4.48122 3.48122 3.25 5 3.25H19C20.5188 3.25 21.75 4.48122 21.75 6V20C21.75 21.5188 20.5188 22.75 19 22.75H5C3.48122 22.75 2.25 21.5188 2.25 20V6Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.25 10C2.25 9.58579 2.58579 9.25 3 9.25H21C21.4142 9.25 21.75 9.58579 21.75 10C21.75 10.4142 21.4142 10.75 21 10.75H3C2.58579 10.75 2.25 10.4142 2.25 10Z'
        fill={color}
      />
    </svg>
  );
}

export function AlertIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V12C12.75 12.4142 12.4142 12.75 12 12.75C11.5858 12.75 11.25 12.4142 11.25 12V8C11.25 7.58579 11.5858 7.25 12 7.25ZM11.25 16C11.25 15.5858 11.5858 15.25 12 15.25H12.01C12.4242 15.25 12.76 15.5858 12.76 16C12.76 16.4142 12.4242 16.75 12.01 16.75H12C11.5858 16.75 11.25 16.4142 11.25 16Z'
        fill={color}
      />
    </svg>
  );
}

export function BinIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.15533 3.15533C8.88559 3.42507 8.75 3.74392 8.75 4V5.25H15.25V4C15.25 3.74392 15.1144 3.42507 14.8447 3.15533C14.5749 2.88559 14.2561 2.75 14 2.75H10C9.74392 2.75 9.42507 2.88559 9.15533 3.15533ZM16.75 5.25V4C16.75 3.25608 16.3856 2.57493 15.9053 2.09467C15.4251 1.61441 14.7439 1.25 14 1.25H10C9.25608 1.25 8.57493 1.61441 8.09467 2.09467C7.61441 2.57493 7.25 3.25608 7.25 4V5.25H3C2.58579 5.25 2.25 5.58579 2.25 6C2.25 6.41421 2.58579 6.75 3 6.75H4.25V20C4.25 20.7439 4.61441 21.4251 5.09467 21.9053C5.57493 22.3856 6.25608 22.75 7 22.75H17C17.7439 22.75 18.4251 22.3856 18.9053 21.9053C19.3856 21.4251 19.75 20.7439 19.75 20V6.75H21C21.4142 6.75 21.75 6.41421 21.75 6C21.75 5.58579 21.4142 5.25 21 5.25H16.75ZM5.75 6.75V20C5.75 20.2561 5.88559 20.5749 6.15533 20.8447C6.42507 21.1144 6.74392 21.25 7 21.25H17C17.2561 21.25 17.5749 21.1144 17.8447 20.8447C18.1144 20.5749 18.25 20.2561 18.25 20V6.75H5.75ZM10 10.25C10.4142 10.25 10.75 10.5858 10.75 11V17C10.75 17.4142 10.4142 17.75 10 17.75C9.58579 17.75 9.25 17.4142 9.25 17V11C9.25 10.5858 9.58579 10.25 10 10.25ZM14 10.25C14.4142 10.25 14.75 10.5858 14.75 11V17C14.75 17.4142 14.4142 17.75 14 17.75C13.5858 17.75 13.25 17.4142 13.25 17V11C13.25 10.5858 13.5858 10.25 14 10.25Z'
        fill={color}
      />
    </svg>
  );
}

export function DollarIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 12 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6 0.0416641C6.34518 0.0416641 6.625 0.321486 6.625 0.666664V2.54166H10.1667C10.5118 2.54166 10.7917 2.82149 10.7917 3.16666C10.7917 3.51184 10.5118 3.79166 10.1667 3.79166H6.625V8.375H8.08333C9.02264 8.375 9.92348 8.74814 10.5877 9.41233C11.2519 10.0765 11.625 10.9774 11.625 11.9167C11.625 12.856 11.2519 13.7568 10.5877 14.421C9.92348 15.0852 9.02264 15.4583 8.08333 15.4583H6.625V17.3333C6.625 17.6785 6.34518 17.9583 6 17.9583C5.65482 17.9583 5.375 17.6785 5.375 17.3333V15.4583H1C0.654822 15.4583 0.375 15.1785 0.375 14.8333C0.375 14.4882 0.654822 14.2083 1 14.2083H5.375V9.625H3.91667C2.97736 9.625 2.07652 9.25186 1.41233 8.58767C0.748139 7.92348 0.375 7.02264 0.375 6.08333C0.375 5.14402 0.748139 4.24319 1.41233 3.57899C2.07652 2.9148 2.97736 2.54166 3.91667 2.54166H5.375V0.666664C5.375 0.321486 5.65482 0.0416641 6 0.0416641ZM5.375 3.79166H3.91667C3.30888 3.79166 2.72598 4.03311 2.29621 4.46288C1.86644 4.89265 1.625 5.47554 1.625 6.08333C1.625 6.69112 1.86644 7.27401 2.29621 7.70378C2.72598 8.13356 3.30888 8.375 3.91667 8.375H5.375V3.79166ZM6.625 9.625V14.2083H8.08333C8.69112 14.2083 9.27402 13.9669 9.70379 13.5371C10.1336 13.1073 10.375 12.5245 10.375 11.9167C10.375 11.3089 10.1336 10.726 9.70379 10.2962C9.27402 9.86644 8.69112 9.625 8.08333 9.625H6.625Z'
        fill={color}
      />
    </svg>
  );
}

export function EditIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.6577 2.2945C17.327 1.62529 18.2349 1.24939 19.1814 1.24951C20.1279 1.24963 21.0356 1.62575 21.7048 2.29513C22.374 2.96451 22.7499 3.87231 22.7498 4.81884C22.7497 5.76532 22.3736 6.67298 21.7043 7.34218L8.35642 20.6921C8.03766 21.0098 7.64578 21.2445 7.21517 21.3754L2.85984 22.6961C2.64373 22.7611 2.41407 22.7664 2.19523 22.7113C1.97639 22.6563 1.77652 22.5431 1.61683 22.3837C1.45714 22.2242 1.34358 22.0245 1.28821 21.8058C1.23284 21.587 1.23772 21.3574 1.30234 21.1411L2.62427 16.7861C2.75698 16.3532 2.99292 15.9614 3.31195 15.6432L16.6577 2.2945Z'
        fill={color}
      />
    </svg>
  );
}

export function EarthIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 2.59C7.41421 2.59 7.75 2.92579 7.75 3.34V5C7.75 5.59674 7.98705 6.16903 8.40901 6.59099C8.83097 7.01295 9.40326 7.25 10 7.25C10.7293 7.25 11.4288 7.53973 11.9445 8.05546C12.4603 8.57118 12.75 9.27065 12.75 10C12.75 10.6858 13.3142 11.25 14 11.25C14.3315 11.25 14.6495 11.1183 14.8839 10.8839C15.1183 10.6495 15.25 10.3315 15.25 10C15.25 8.48579 16.4858 7.25 18 7.25H21.17C21.5842 7.25 21.92 7.58579 21.92 8C21.92 8.41421 21.5842 8.75 21.17 8.75H18C17.3142 8.75 16.75 9.31421 16.75 10C16.75 10.7293 16.4603 11.4288 15.9445 11.9445C15.4288 12.4603 14.7293 12.75 14 12.75C12.4858 12.75 11.25 11.5142 11.25 10C11.25 9.66848 11.1183 9.35054 10.8839 9.11612C10.6495 8.8817 10.3315 8.75 10 8.75C9.00544 8.75 8.05161 8.35491 7.34835 7.65165C6.64509 6.94839 6.25 5.99456 6.25 5V3.34C6.25 2.92579 6.58579 2.59 7 2.59Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z'
        fill={color}
      />
    </svg>
  );
}

export function DashboardIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4 3.75C3.86193 3.75 3.75 3.86193 3.75 4V11C3.75 11.1381 3.86193 11.25 4 11.25H9C9.13807 11.25 9.25 11.1381 9.25 11V4C9.25 3.86193 9.13807 3.75 9 3.75H4ZM2.25 4C2.25 3.0335 3.0335 2.25 4 2.25H9C9.9665 2.25 10.75 3.0335 10.75 4V11C10.75 11.9665 9.9665 12.75 9 12.75H4C3.0335 12.75 2.25 11.9665 2.25 11V4Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15 3.75C14.8619 3.75 14.75 3.86193 14.75 4V7C14.75 7.13807 14.8619 7.25 15 7.25H20C20.1381 7.25 20.25 7.13807 20.25 7V4C20.25 3.86193 20.1381 3.75 20 3.75H15ZM13.25 4C13.25 3.0335 14.0335 2.25 15 2.25H20C20.9665 2.25 21.75 3.0335 21.75 4V7C21.75 7.9665 20.9665 8.75 20 8.75H15C14.0335 8.75 13.25 7.9665 13.25 7V4Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15 12.75C14.8619 12.75 14.75 12.8619 14.75 13V20C14.75 20.1381 14.8619 20.25 15 20.25H20C20.1381 20.25 20.25 20.1381 20.25 20V13C20.25 12.8619 20.1381 12.75 20 12.75H15ZM13.25 13C13.25 12.0335 14.0335 11.25 15 11.25H20C20.9665 11.25 21.75 12.0335 21.75 13V20C21.75 20.9665 20.9665 21.75 20 21.75H15C14.0335 21.75 13.25 20.9665 13.25 20V13Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4 16.75C3.86193 16.75 3.75 16.8619 3.75 17V20C3.75 20.1381 3.86193 20.25 4 20.25H9C9.13807 20.25 9.25 20.1381 9.25 20V17C9.25 16.8619 9.13807 16.75 9 16.75H4ZM2.25 17C2.25 16.0335 3.0335 15.25 4 15.25H9C9.9665 15.25 10.75 16.0335 10.75 17V20C10.75 20.9665 9.9665 21.75 9 21.75H4C3.0335 21.75 2.25 20.9665 2.25 20V17Z'
        fill={color}
      />
    </svg>
  );
}

export function DiscountIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.5303 4.46967C19.8232 4.76256 19.8232 5.23744 19.5303 5.53033L5.53033 19.5303C5.23744 19.8232 4.76256 19.8232 4.46967 19.5303C4.17678 19.2374 4.17678 18.7626 4.46967 18.4697L18.4697 4.46967C18.7626 4.17678 19.2374 4.17678 19.5303 4.46967Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.5 4.75C5.5335 4.75 4.75 5.5335 4.75 6.5C4.75 7.4665 5.5335 8.25 6.5 8.25C7.4665 8.25 8.25 7.4665 8.25 6.5C8.25 5.5335 7.4665 4.75 6.5 4.75ZM3.25 6.5C3.25 4.70507 4.70507 3.25 6.5 3.25C8.29493 3.25 9.75 4.70507 9.75 6.5C9.75 8.29493 8.29493 9.75 6.5 9.75C4.70507 9.75 3.25 8.29493 3.25 6.5Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.5 15.75C16.5335 15.75 15.75 16.5335 15.75 17.5C15.75 18.4665 16.5335 19.25 17.5 19.25C18.4665 19.25 19.25 18.4665 19.25 17.5C19.25 16.5335 18.4665 15.75 17.5 15.75ZM14.25 17.5C14.25 15.7051 15.7051 14.25 17.5 14.25C19.2949 14.25 20.75 15.7051 20.75 17.5C20.75 19.2949 19.2949 20.75 17.5 20.75C15.7051 20.75 14.25 19.2949 14.25 17.5Z'
        fill={color}
      />
    </svg>
  );
}

export function CreditIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4 5.75C3.30964 5.75 2.75 6.30964 2.75 7V17C2.75 17.6904 3.30964 18.25 4 18.25H20C20.6904 18.25 21.25 17.6904 21.25 17V7C21.25 6.30964 20.6904 5.75 20 5.75H4ZM1.25 7C1.25 5.48122 2.48122 4.25 4 4.25H20C21.5188 4.25 22.75 5.48122 22.75 7V17C22.75 18.5188 21.5188 19.75 20 19.75H4C2.48122 19.75 1.25 18.5188 1.25 17V7Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.25 10C1.25 9.58579 1.58579 9.25 2 9.25H22C22.4142 9.25 22.75 9.58579 22.75 10C22.75 10.4142 22.4142 10.75 22 10.75H2C1.58579 10.75 1.25 10.4142 1.25 10Z'
        fill={color}
      />
    </svg>
  );
}

export function DoneIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.5303 9.46967C15.8232 9.76256 15.8232 10.2374 15.5303 10.5303L11.5303 14.5303C11.2374 14.8232 10.7626 14.8232 10.4697 14.5303L8.46967 12.5303C8.17678 12.2374 8.17678 11.7626 8.46967 11.4697C8.76256 11.1768 9.23744 11.1768 9.53033 11.4697L11 12.9393L14.4697 9.46967C14.7626 9.17678 15.2374 9.17678 15.5303 9.46967Z'
        fill={color}
      />
    </svg>
  );
}

export function DislikeIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.07997 2.5C5.80951 2.5 5.54634 2.58772 5.32997 2.75C5.11368 2.91222 4.95581 3.14019 4.88005 3.39972L2.55005 11.3997C2.49572 11.586 2.48542 11.7827 2.52014 11.9736C2.55485 12.1645 2.63354 12.3448 2.74997 12.5C2.86641 12.6552 3.01739 12.7812 3.19096 12.868C3.36452 12.9548 3.55592 13 3.74997 13H9.57997C9.81002 13 10.0273 13.1056 10.1695 13.2864C10.3117 13.4673 10.3631 13.7033 10.3088 13.9269L9.30881 18.0469L9.30811 18.0498C9.22215 18.3979 9.21598 18.761 9.29006 19.1119C9.36414 19.4627 9.51654 19.7923 9.7359 20.076C9.95525 20.3597 10.2359 20.5902 10.5568 20.7502C10.7425 20.8428 10.9389 20.9104 11.1409 20.9518L14.3583 14.5262C14.3585 14.5259 14.3587 14.5255 14.3589 14.5252C14.5866 14.0675 14.9373 13.6823 15.3718 13.4129C15.5177 13.3224 15.6712 13.2461 15.83 13.1848V2.5H6.07997Z'
        fill={color}
      />
    </svg>
  );
}

export function CloseIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L12 10.9393L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L13.0607 12L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L12 13.0607L6.53033 18.5303C6.23744 18.8232 5.76256 18.8232 5.46967 18.5303C5.17678 18.2374 5.17678 17.7626 5.46967 17.4697L10.9393 12L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z'
        fill={color}
      />
    </svg>
  );
}

export function CollapseIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.46967 8.46967C5.76256 8.17678 6.23744 8.17678 6.53033 8.46967L12 13.9393L17.4697 8.46967C17.7626 8.17678 18.2374 8.17678 18.5303 8.46967C18.8232 8.76256 18.8232 9.23744 18.5303 9.53033L12.5303 15.5303C12.2374 15.8232 11.7626 15.8232 11.4697 15.5303L5.46967 9.53033C5.17678 9.23744 5.17678 8.76256 5.46967 8.46967Z'
        fill={color}
      />
    </svg>
  );
}

export function ErrorIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.46967 8.46967C8.76256 8.17678 9.23744 8.17678 9.53033 8.46967L12 10.9393L14.4697 8.46967C14.7626 8.17678 15.2374 8.17678 15.5303 8.46967C15.8232 8.76256 15.8232 9.23744 15.5303 9.53033L13.0607 12L15.5303 14.4697C15.8232 14.7626 15.8232 15.2374 15.5303 15.5303C15.2374 15.8232 14.7626 15.8232 14.4697 15.5303L12 13.0607L9.53033 15.5303C9.23744 15.8232 8.76256 15.8232 8.46967 15.5303C8.17678 15.2374 8.17678 14.7626 8.46967 14.4697L10.9393 12L8.46967 9.53033C8.17678 9.23744 8.17678 8.76256 8.46967 8.46967Z'
        fill={color}
      />
    </svg>
  );
}

export function HamburgerMenuIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.25 6C3.25 5.58579 3.58579 5.25 4 5.25H20C20.4142 5.25 20.75 5.58579 20.75 6C20.75 6.41421 20.4142 6.75 20 6.75H4C3.58579 6.75 3.25 6.41421 3.25 6ZM3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H4C3.58579 12.75 3.25 12.4142 3.25 12ZM3.25 18C3.25 17.5858 3.58579 17.25 4 17.25H20C20.4142 17.25 20.75 17.5858 20.75 18C20.75 18.4142 20.4142 18.75 20 18.75H4C3.58579 18.75 3.25 18.4142 3.25 18Z'
        fill={color}
      />
    </svg>
  );
}

export function FacebookIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        d='M9.60002 21.6V12H6.40002V8.80002H9.60002V7.08162C9.60002 3.82802 11.1848 2.40002 13.8888 2.40002C15.184 2.40002 15.8688 2.49602 16.1928 2.54002V5.60002H14.3488C13.2008 5.60002 12.8 6.20562 12.8 7.43282V8.80002H16.164L15.7072 12H12.8V21.6H9.60002Z'
        fill={color}
      />
    </svg>
  );
}

export function ExpandIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.4697 8.46967C11.7626 8.17678 12.2374 8.17678 12.5303 8.46967L18.5303 14.4697C18.8232 14.7626 18.8232 15.2374 18.5303 15.5303C18.2374 15.8232 17.7626 15.8232 17.4697 15.5303L12 10.0607L6.53033 15.5303C6.23744 15.8232 5.76256 15.8232 5.46967 15.5303C5.17678 15.2374 5.17678 14.7626 5.46967 14.4697L11.4697 8.46967Z'
        fill={color}
      />
    </svg>
  );
}

export function GoogleIcon({
  size = 24,
  className = '',
}: Omit<IconProps, 'color'>) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        d='M21.5836 12.2287C21.5836 11.4978 21.5183 10.7981 21.3968 10.1259H12.0003V13.9791L17.4123 13.9803C17.1925 15.2625 16.4867 16.3554 15.4042 17.0838V19.117C15.4042 19.3746 15.613 19.5834 15.8706 19.5834H18.6255C20.506 17.8421 21.5836 15.2686 21.5836 12.2287Z'
        fill='#4285F4'
      />
      <path
        d='M15.4042 17.0838C14.5072 17.6889 13.3533 18.0418 12.0021 18.0418C9.39262 18.0418 7.17874 16.2834 6.38624 13.9132H3.53005C3.2724 13.9132 3.06298 14.122 3.06298 14.3803V16.4916C4.70904 19.7586 8.09274 22 12.0021 22C14.7038 22 16.9739 21.1116 18.6261 19.5822L15.4042 17.0838Z'
        fill='#34A853'
      />
      <path
        d='M6.07363 12.0009C6.07363 11.3354 6.18475 10.6919 6.38685 10.0874V7.97674C6.38685 7.71847 6.17743 7.50905 5.91916 7.50905H3.06359C2.38282 8.86021 2 10.3848 2 12.0009C2 13.6171 2.38404 15.1416 3.06359 16.4928L6.38685 13.915C6.18414 13.3093 6.07363 12.6664 6.07363 12.0009Z'
        fill='#FBBC04'
      />
      <path
        d='M12.0021 5.95824C13.4766 5.95824 14.7973 6.46622 15.8401 7.45837L18.6951 4.60586C16.9611 2.99093 14.7008 2 12.0021 2C8.09396 2 4.70965 4.24257 3.06359 7.50905L6.38624 10.0862C7.17935 7.71664 9.39262 5.95824 12.0021 5.95824Z'
        fill='#EA4335'
      />
    </svg>
  );
}

export function ForwardIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.46967 5.46967C8.76256 5.17678 9.23744 5.17678 9.53033 5.46967L15.5303 11.4697C15.8232 11.7626 15.8232 12.2374 15.5303 12.5303L9.53033 18.5303C9.23744 18.8232 8.76256 18.8232 8.46967 18.5303C8.17678 18.2374 8.17678 17.7626 8.46967 17.4697L13.9393 12L8.46967 6.53033C8.17678 6.23744 8.17678 5.76256 8.46967 5.46967Z'
        fill={color}
      />
    </svg>
  );
}

export function HalfStarIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        opacity='0.4'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 1.25C12.2855 1.25 12.5462 1.41205 12.6726 1.66803L15.5882 7.57485L22.1085 8.52789C22.3909 8.56917 22.6254 8.76717 22.7135 9.03868C22.8015 9.31018 22.7278 9.60812 22.5233 9.80727L17.8059 14.402L18.9192 20.8932C18.9675 21.1746 18.8518 21.459 18.6208 21.6268C18.3898 21.7946 18.0836 21.8167 17.8309 21.6838L12 18.6174L6.16911 21.6838C5.91642 21.8167 5.6102 21.7946 5.37922 21.6268C5.14824 21.459 5.03255 21.1746 5.08082 20.8932L6.19413 14.402L1.47672 9.80727C1.27226 9.60812 1.19855 9.31018 1.28659 9.03868C1.37462 8.76717 1.60913 8.56917 1.89155 8.52789L8.41183 7.57485L11.3275 1.66803C11.4538 1.41205 11.7146 1.25 12 1.25Z'
        fill={color}
      />
      <path
        d='M12 18.6174L6.16911 21.6838C5.91642 21.8167 5.6102 21.7946 5.37922 21.6268C5.14824 21.459 5.03255 21.1746 5.08082 20.8932L6.19413 14.402L1.47672 9.80727C1.27226 9.60812 1.19855 9.31018 1.28659 9.03868C1.37462 8.76717 1.60913 8.56917 1.89155 8.52789L8.41183 7.57485L11.3275 1.66803C11.4538 1.41205 11.7146 1.25 12 1.25V18.6174Z'
        fill={color}
      />
    </svg>
  );
}

export function FilterIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.25 6C2.25 5.58579 2.58579 5.25 3 5.25H21C21.4142 5.25 21.75 5.58579 21.75 6C21.75 6.41421 21.4142 6.75 21 6.75H3C2.58579 6.75 2.25 6.41421 2.25 6ZM6.25 12C6.25 11.5858 6.58579 11.25 7 11.25H17C17.4142 11.25 17.75 11.5858 17.75 12C17.75 12.4142 17.4142 12.75 17 12.75H7C6.58579 12.75 6.25 12.4142 6.25 12ZM9.25 18C9.25 17.5858 9.58579 17.25 10 17.25H14C14.4142 17.25 14.75 17.5858 14.75 18C14.75 18.4142 14.4142 18.75 14 18.75H10C9.58579 18.75 9.25 18.4142 9.25 18Z'
        fill={color}
      />
    </svg>
  );
}

export function FacebookColorIcon({
  size = 24,
  className = '',
}: Omit<IconProps, 'color'>) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        d='M12 1C9.08262 1 6.28473 2.15683 4.22183 4.216C2.15893 6.27516 1 9.068 1 11.9801C1 14.8922 2.15893 17.685 4.22183 19.7442C6.28473 21.8034 9.08262 22.9602 12 22.9602C14.9174 22.9602 17.7153 21.8034 19.7782 19.7442C21.8411 17.685 23 14.8922 23 11.9801C23 9.068 21.8411 6.27516 19.7782 4.216C17.7153 2.15683 14.9174 1 12 1Z'
        fill='#0866FF'
      />
      <path
        d='M13.5003 14.8691H16.3686L16.8189 11.9606H13.4997V10.371C13.4997 9.16275 13.8953 8.09136 15.0275 8.09136H16.8469V5.55321C16.5272 5.51012 15.8512 5.41579 14.5737 5.41579C11.9061 5.41579 10.3422 6.82199 10.3422 10.0257V11.9606H7.59992V14.8691H10.3422V22.8632C10.8853 22.9447 11.4353 23 12 23C12.5104 23 13.0086 22.9534 13.5003 22.887V14.8691Z'
        fill='white'
      />
    </svg>
  );
}

export function HideIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.74286 7.2954C2.13198 7.15341 2.56252 7.35374 2.70452 7.74286C3.3748 9.57971 4.57365 11.1752 6.14769 12.3297C6.16094 12.3387 6.17398 12.3482 6.1868 12.3582C6.23347 12.3921 6.28047 12.4256 6.32779 12.4587C7.99053 13.622 9.97071 14.2458 12 14.2458C14.0292 14.2458 16.0094 13.622 17.6721 12.4587C17.7195 12.4256 17.7665 12.3921 17.8131 12.3582C17.8259 12.3482 17.839 12.3387 17.8522 12.3297C19.4263 11.1752 20.6251 9.57972 21.2954 7.74286C21.4374 7.35374 21.8679 7.15341 22.2571 7.2954C22.6462 7.4374 22.8465 7.86794 22.7045 8.25706C22.0214 10.129 20.8616 11.7833 19.3475 13.0606L20.5737 14.5169C20.8405 14.8338 20.7999 15.3069 20.483 15.5737C20.1661 15.8405 19.693 15.7999 19.4262 15.483L18.1371 13.9519C17.213 14.5427 16.2124 14.9943 15.1677 15.2967L15.7321 17.8373C15.8219 18.2417 15.567 18.6423 15.1626 18.7321C14.7583 18.8219 14.3576 18.567 14.2678 18.1626L13.7025 15.6179C13.1414 15.7027 12.5724 15.7458 12 15.7458C11.4275 15.7458 10.8585 15.7027 10.2974 15.6179L9.73211 18.1626C9.64228 18.567 9.24167 18.8219 8.83731 18.7321C8.43295 18.6423 8.17798 18.2417 8.26781 17.8373L8.83222 15.2967C7.78752 14.9943 6.78696 14.5427 5.86277 13.9519L4.57369 15.483C4.30691 15.7999 3.83377 15.8405 3.51691 15.5737C3.20005 15.3069 3.15945 14.8338 3.42623 14.5169L4.65239 13.0606C3.13831 11.7833 1.97851 10.129 1.2954 8.25706C1.15341 7.86794 1.35374 7.4374 1.74286 7.2954Z'
        fill={color}
      />
    </svg>
  );
}

export function HomeIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.76256 11.7625C9.09075 11.4343 9.53587 11.25 10 11.25H14C14.4641 11.25 14.9092 11.4343 15.2374 11.7625C15.5656 12.0907 15.75 12.5358 15.75 13V21C15.75 21.4142 15.4142 21.75 15 21.75C14.5858 21.75 14.25 21.4142 14.25 21V13C14.25 12.9337 14.2237 12.8701 14.1768 12.8232C14.1299 12.7763 14.0663 12.75 14 12.75H10C9.9337 12.75 9.87011 12.7763 9.82322 12.8232C9.77634 12.8701 9.75 12.9337 9.75 13V21C9.75 21.4142 9.41421 21.75 9 21.75C8.58579 21.75 8.25 21.4142 8.25 21V13C8.25 12.5358 8.43437 12.0907 8.76256 11.7625Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.1949 3.04432L4.19314 9.0448C4.05426 9.16217 3.94265 9.30842 3.86612 9.47336C3.78958 9.6383 3.74996 9.81796 3.75 9.99979V19C3.75 19.3315 3.8817 19.6494 4.11612 19.8839C4.35054 20.1183 4.66848 20.25 5 20.25H19C19.3315 20.25 19.6495 20.1183 19.8839 19.8839C20.1183 19.6494 20.25 19.3315 20.25 19V9.99997C20.25 9.81813 20.2104 9.6383 20.1339 9.47336C20.0574 9.30842 19.9458 9.16216 19.8069 9.04479L19.8029 9.04146L12.8069 3.04579L12.8051 3.04432C12.5798 2.85457 12.2946 2.75049 12 2.75049C11.7054 2.75049 11.4202 2.85457 11.1949 3.04432Z'
        fill={color}
      />
    </svg>
  );
}

export function HeadphoneIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 2.75C10.9166 2.75 9.8438 2.96339 8.84286 3.37799C7.84193 3.7926 6.93245 4.40029 6.16637 5.16637C5.40029 5.93245 4.79259 6.84193 4.37799 7.84286C4.05938 8.61207 3.85959 9.42371 3.78416 10.25H6C6.72935 10.25 7.42882 10.5397 7.94454 11.0555C8.46027 11.5712 8.75 12.2707 8.75 13V16C8.75 16.7293 8.46027 17.4288 7.94454 17.9445C7.42882 18.4603 6.72935 18.75 6 18.75H5C4.27065 18.75 3.57118 18.4603 3.05546 17.9445C2.53973 17.4288 2.25 16.7293 2.25 16V11C2.25 9.71961 2.50219 8.45176 2.99217 7.26884C3.48216 6.08591 4.20034 5.01108 5.10571 4.10571C6.01108 3.20034 7.08591 2.48216 8.26884 1.99217C9.45176 1.50219 10.7196 1.25 12 1.25C13.2804 1.25 14.5482 1.50219 15.7312 1.99217C16.9141 2.48216 17.9889 3.20034 18.8943 4.10571C19.7997 5.01108 20.5178 6.08591 21.0078 7.26884C21.4978 8.45176 21.75 9.71961 21.75 11V16C21.75 16.7293 21.4603 17.4288 20.9445 17.9445C20.4288 18.4603 19.7293 18.75 19 18.75H18C17.2707 18.75 16.5712 18.4603 16.0555 17.9445C15.5397 17.4288 15.25 16.7293 15.25 16V13C15.25 12.2707 15.5397 11.5712 16.0555 11.0555C16.5712 10.5397 17.2707 10.25 18 10.25H20.2158C20.1404 9.42371 19.9406 8.61207 19.622 7.84286C19.2074 6.84193 18.5997 5.93245 17.8336 5.16637C17.0675 4.40029 16.1581 3.7926 15.1571 3.37799C14.1562 2.96339 13.0834 2.75 12 2.75Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21 15.25C21.4142 15.25 21.75 15.5858 21.75 16V18C21.75 19.2598 21.2496 20.468 20.3588 21.3588C19.468 22.2496 18.2598 22.75 17 22.75H12C11.5858 22.75 11.25 22.4142 11.25 22C11.25 21.5858 11.5858 21.25 12 21.25H17C17.862 21.25 18.6886 20.9076 19.2981 20.2981C19.9076 19.6886 20.25 18.862 20.25 18V16C20.25 15.5858 20.5858 15.25 21 15.25Z'
        fill={color}
      />
    </svg>
  );
}

export function LikeIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.0794 1.4142C11.208 1.15733 11.472 0.996501 11.7593 1.00006C12.3439 1.0073 12.9192 1.14654 13.4424 1.40739C13.9656 1.66824 14.4231 2.04395 14.7807 2.50644C15.1383 2.96894 15.3868 3.50627 15.5076 4.07828C15.6282 4.64969 15.6183 5.24097 15.4786 5.808L14.7038 9H19.58C20.0069 9 20.428 9.0994 20.8098 9.29033C21.1917 9.48125 21.5238 9.75846 21.78 10.1C22.0362 10.4415 22.2093 10.838 22.2856 11.2581C22.362 11.678 22.3396 12.11 22.2201 12.5197L19.8901 20.5197C19.7235 21.0909 19.376 21.593 18.9 21.95C18.424 22.307 17.845 22.5 17.25 22.5H3.75C3.02065 22.5 2.32118 22.2103 1.80546 21.6945C1.28973 21.1788 1 20.4793 1 19.75V11.75C1 11.0207 1.28973 10.3212 1.80546 9.80546C2.32118 9.28973 3.02065 9 3.75 9H6.5096C6.74215 8.99988 6.97006 8.93488 7.1677 8.81233C7.36534 8.68977 7.52487 8.51451 7.62835 8.30625L11.0794 1.4142Z'
        fill={color}
      />
    </svg>
  );
}

export function HeartIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.08058 4.08058C4.25269 2.90848 5.8424 2.25 7.5 2.25C8.45514 2.25 9.31239 2.38639 10.147 2.74989C10.7904 3.03013 11.3924 3.4332 12 3.96975C12.6076 3.4332 13.2096 3.03013 13.853 2.74989C14.6876 2.38639 15.5449 2.25 16.5 2.25C18.1576 2.25 19.7473 2.90848 20.9194 4.08058C22.0915 5.25269 22.75 6.8424 22.75 8.5C22.75 11.1289 21.0154 13.0749 19.5276 14.533L12.5303 21.5303C12.2374 21.8232 11.7626 21.8232 11.4697 21.5303L4.47414 14.5348C2.97096 13.0812 1.25 11.1372 1.25 8.5C1.25 6.8424 1.90848 5.25269 3.08058 4.08058ZM7.5 3.75C6.24022 3.75 5.03204 4.25045 4.14124 5.14124C3.25045 6.03204 2.75 7.24022 2.75 8.5C2.75 10.4601 4.02553 12.0149 5.52127 13.4608L5.53041 13.4696L12 19.9393L18.4751 13.4643C19.9667 12.0027 21.25 10.4495 21.25 8.5C21.25 7.24022 20.7496 6.03204 19.8588 5.14124C18.968 4.25045 17.7598 3.75 16.5 3.75C15.6951 3.75 15.0524 3.86361 14.452 4.12511C13.8467 4.38872 13.2376 4.82308 12.5303 5.53033C12.2374 5.82322 11.7626 5.82322 11.4697 5.53033C10.7624 4.82308 10.1533 4.38872 9.54802 4.12511C8.94761 3.86361 8.30486 3.75 7.5 3.75Z'
        fill={color}
      />
    </svg>
  );
}

export function HeartFilledIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.08058 4.08058C4.25269 2.90848 5.8424 2.25 7.5 2.25C8.45514 2.25 9.31239 2.38639 10.147 2.74989C10.7904 3.03013 11.3924 3.4332 12 3.96975C12.6076 3.4332 13.2096 3.03013 13.853 2.74989C14.6876 2.38639 15.5449 2.25 16.5 2.25C18.1576 2.25 19.7473 2.90848 20.9194 4.08058C22.0915 5.25269 22.75 6.8424 22.75 8.5C22.75 11.1289 21.0154 13.0749 19.5276 14.533L12.5303 21.5303C12.2374 21.8232 11.7626 21.8232 11.4697 21.5303L4.47414 14.5348C2.97096 13.0812 1.25 11.1372 1.25 8.5C1.25 6.8424 1.90848 5.25269 3.08058 4.08058Z'
        fill={color}
      />
    </svg>
  );
}

export function InfoIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 16V12M12 8H12.01'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function KebabMenuIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.25 12C10.25 11.0335 11.0335 10.25 12 10.25C12.9665 10.25 13.75 11.0335 13.75 12C13.75 12.9665 12.9665 13.75 12 13.75C11.0335 13.75 10.25 12.9665 10.25 12Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.25 5C10.25 4.0335 11.0335 3.25 12 3.25C12.9665 3.25 13.75 4.0335 13.75 5C13.75 5.9665 12.9665 6.75 12 6.75C11.0335 6.75 10.25 5.9665 10.25 5Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.25 19C10.25 18.0335 11.0335 17.25 12 17.25C12.9665 17.25 13.75 18.0335 13.75 19C13.75 19.9665 12.9665 20.75 12 20.75C11.0335 20.75 10.25 19.9665 10.25 19Z'
        fill={color}
      />
    </svg>
  );
}

export function LanguageIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.25 2C6.25 1.58579 6.58579 1.25 7 1.25H8C8.41421 1.25 8.75 1.58579 8.75 2C8.75 2.41421 8.41421 2.75 8 2.75H7C6.58579 2.75 6.25 2.41421 6.25 2ZM11.9897 4.25H2C1.58579 4.25 1.25 4.58579 1.25 5C1.25 5.41421 1.58579 5.75 2 5.75H10.5986L9.41716 7.52218L7.5 9.43934L5.53033 7.46967C5.23744 7.17678 4.76256 7.17678 4.46967 7.46967C4.17678 7.76256 4.17678 8.23744 4.46967 8.53033L6.43934 10.5L3.46967 13.4697C3.17678 13.7626 3.17678 14.2374 3.46967 14.5303C3.76256 14.8232 4.23744 14.8232 4.53033 14.5303L7.5 11.5607L10.4697 14.5303C10.7626 14.8232 11.2374 14.8232 11.5303 14.5303C11.8232 14.2374 11.8232 13.7626 11.5303 13.4697L8.56066 10.5L10.5303 8.53033C10.5653 8.49541 10.5966 8.45712 10.624 8.41603L12.4014 5.75H14C14.4142 5.75 14.75 5.41421 14.75 5C14.75 4.58579 14.4142 4.25 14 4.25H12.0116C12.0043 4.24989 11.997 4.24989 11.9897 4.25ZM17 11.25C17.2841 11.25 17.5438 11.4105 17.6708 11.6646L20.6641 17.6511C20.6689 17.6603 20.6736 17.6697 20.6781 17.6791L22.6708 21.6646C22.8561 22.0351 22.7059 22.4856 22.3354 22.6708C21.9649 22.8561 21.5144 22.7059 21.3292 22.3354L19.5365 18.75H14.4635L12.6708 22.3354C12.4856 22.7059 12.0351 22.8561 11.6646 22.6708C11.2941 22.4856 11.1439 22.0351 11.3292 21.6646L13.3219 17.6791C13.3264 17.6697 13.3311 17.6603 13.3359 17.6511L16.3292 11.6646C16.4562 11.4105 16.7159 11.25 17 11.25ZM15.2135 17.25H18.7865L17 13.6771L15.2135 17.25Z'
        fill={color}
      />
    </svg>
  );
}

export function InstagramIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        d='M12 6.86499C10.9844 6.86499 9.99159 7.16615 9.14714 7.73039C8.30269 8.29463 7.64453 9.09661 7.25587 10.0349C6.86722 10.9732 6.76553 12.0057 6.96366 13.0018C7.1618 13.9979 7.65086 14.9128 8.369 15.631C9.08714 16.3491 10.0021 16.8382 10.9982 17.0363C11.9943 17.2345 13.0268 17.1328 13.9651 16.7441C14.9034 16.3555 15.7053 15.6973 16.2696 14.8528C16.8338 14.0084 17.135 13.0156 17.135 12C17.135 10.6381 16.594 9.332 15.631 8.369C14.668 7.406 13.3619 6.86499 12 6.86499Z'
        fill={color}
      />
      <path
        fill={color}
        d='M21.94 7.877C21.924 7.04745 21.7668 6.2267 21.475 5.45C21.2242 4.78247 20.8307 4.17773 20.322 3.678C19.8228 3.16955 19.2188 2.77607 18.552 2.525C17.7749 2.23343 16.9538 2.07652 16.124 2.061C15.058 2.012 14.717 2 12.001 2C9.28498 2 8.94398 2.011 7.87798 2.06C7.04809 2.07584 6.22699 2.23309 5.44998 2.525C4.78316 2.77607 4.17913 3.16955 3.67998 3.678C3.17056 4.17754 2.77638 4.78229 2.52498 5.45C2.23352 6.22676 2.07661 7.04751 2.06098 7.877C2.01098 8.943 2.00098 9.284 2.00098 12C2.00098 14.716 2.01098 15.057 2.06098 16.123C2.07661 16.9525 2.23352 17.7732 2.52498 18.55C2.77609 19.2176 3.16992 19.8224 3.67898 20.322C4.17842 20.8306 4.78281 21.2241 5.44998 21.475C6.22705 21.7666 7.04815 21.9235 7.87798 21.939C8.94398 21.988 9.28498 22 12 22C14.715 22 15.057 21.989 16.123 21.94C16.9525 21.924 17.7733 21.7668 18.55 21.475C19.2148 21.2188 19.8186 20.8262 20.3223 20.3224C20.8261 19.8186 21.2188 19.2148 21.475 18.55C21.7668 17.7733 21.924 16.9525 21.94 16.123C21.988 15.056 22 14.716 22 12C22 9.284 21.988 8.943 21.94 7.877ZM20.14 16.041C20.1316 16.675 20.0156 17.3029 19.797 17.898C19.6312 18.3297 19.3766 18.7217 19.0497 19.0487C18.7227 19.3757 18.3307 19.6303 17.899 19.796C17.3044 20.0169 16.6762 20.1333 16.042 20.14C14.987 20.188 14.671 20.198 12 20.198C9.'
      />
    </svg>
  );
}

export function LocationIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 2.75C10.0772 2.75 8.23311 3.51384 6.87348 4.87348C5.51384 6.23311 4.75 8.07718 4.75 10C4.75 12.2436 6.0087 14.6262 7.5988 16.7154C9.15703 18.7627 10.9447 20.4139 11.8637 21.2093C11.9042 21.2356 11.9515 21.2498 12 21.2498C12.0485 21.2498 12.0958 21.2356 12.1363 21.2093C13.0553 20.4139 14.843 18.7627 16.4012 16.7154C17.9913 14.6262 19.25 12.2436 19.25 10C19.25 8.07718 18.4862 6.23311 17.1265 4.87348C15.7669 3.51384 13.9228 2.75 12 2.75Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 7.75C10.7574 7.75 9.75 8.75736 9.75 10C9.75 11.2426 10.7574 12.25 12 12.25C13.2426 12.25 14.25 11.2426 14.25 10C14.25 8.75736 13.2426 7.75 12 7.75Z'
        fill={color}
      />
    </svg>
  );
}

export function MinusThinIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.25 12C4.25 11.5858 4.58579 11.25 5 11.25H19C19.4142 11.25 19.75 11.5858 19.75 12C19.75 12.4142 19.4142 12.75 19 12.75H5C4.58579 12.75 4.25 12.4142 4.25 12Z'
        fill={color}
      />
    </svg>
  );
}

export function MeatballsMenuIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.25 12C10.25 11.0335 11.0335 10.25 12 10.25C12.9665 10.25 13.75 11.0335 13.75 12C13.75 12.9665 12.9665 13.75 12 13.75C11.0335 13.75 10.25 12.9665 10.25 12Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.25 12C17.25 11.0335 18.0335 10.25 19 10.25C19.9665 10.25 20.75 11.0335 20.75 12C20.75 12.9665 19.9665 13.75 19 13.75C18.0335 13.75 17.25 12.9665 17.25 12Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.25 12C3.25 11.0335 4.0335 10.25 5 10.25C5.9665 10.25 6.75 11.0335 6.75 12C6.75 12.9665 5.9665 13.75 5 13.75C4.0335 13.75 3.25 12.9665 3.25 12Z'
        fill={color}
      />
    </svg>
  );
}

export function MinusHeavyIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.75 12C3.75 11.3096 4.30964 10.75 5 10.75H19C19.6904 10.75 20.25 11.3096 20.25 12C20.25 12.6904 19.6904 13.25 19 13.25H5C4.30964 13.25 3.75 12.6904 3.75 12Z'
        fill={color}
      />
    </svg>
  );
}

export function LogoutIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5 3.75C4.66848 3.75 4.35054 3.8817 4.11612 4.11612C3.8817 4.35054 3.75 4.66848 3.75 5V19C3.75 19.3315 3.8817 19.6495 4.11612 19.8839C4.35054 20.1183 4.66848 20.25 5 20.25H9C9.41421 20.25 9.75 20.5858 9.75 21C9.75 21.4142 9.41421 21.75 9 21.75H5C4.27065 21.75 3.57118 21.4603 3.05546 20.9445C2.53973 20.4288 2.25 19.7293 2.25 19V5C2.25 4.27065 2.53973 3.57118 3.05546 3.05546C3.57118 2.53973 4.27065 2.25 5 2.25H9C9.41421 2.25 9.75 2.58579 9.75 3C9.75 3.41421 9.41421 3.75 9 3.75H5Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.4697 6.46967C15.7626 6.17678 16.2374 6.17678 16.5303 6.46967L21.5303 11.4697C21.8232 11.7626 21.8232 12.2374 21.5303 12.5303L16.5303 17.5303C16.2374 17.8232 15.7626 17.8232 15.4697 17.5303C15.1768 17.2374 15.1768 16.7626 15.4697 16.4697L19.1893 12.75H9C8.58579 12.75 8.25 12.4142 8.25 12C8.25 11.5858 8.58579 11.25 9 11.25H19.1893L15.4697 7.53033C15.1768 7.23744 15.1768 6.76256 15.4697 6.46967Z'
        fill={color}
      />
    </svg>
  );
}

export function LinkedinIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.0313 8.46615V10.2986C13.4048 9.70691 13.9258 9.2258 14.5415 8.90401C15.1572 8.58222 15.8458 8.43117 16.5375 8.46615C20.2563 8.46615 21 10.8376 21 13.8558V20H17.6V14.6104C17.6 13.209 17.3875 11.5921 15.3688 11.5921C13.35 11.5921 13.0313 12.9935 13.0313 14.3948V20H9.63125V8.46615H13.0313Z'
        fill={color}
      />
      <path
        d='M7.4 5.55574C7.40842 5.82354 7.35522 6.08965 7.24463 6.33297C7.13403 6.57628 6.96908 6.79011 6.76285 6.95749C6.55662 7.12487 6.31478 7.2412 6.05652 7.29725C5.79826 7.35331 5.53068 7.34755 5.275 7.28043C5.04159 7.21022 4.82578 7.08998 4.64214 6.92783C4.45851 6.76568 4.31134 6.56541 4.2106 6.34056C4.10986 6.11572 4.0579 5.87155 4.05823 5.62456C4.05855 5.37758 4.11117 5.13355 4.2125 4.90898C4.32992 4.68706 4.49383 4.49393 4.6927 4.34315C4.89157 4.19238 5.12057 4.08762 5.36362 4.03625C5.60667 3.98488 5.85786 3.98814 6.09953 4.0458C6.34121 4.10347 6.5675 4.21413 6.7625 4.37002C7.08125 4.6934 7.29375 5.12457 7.29375 5.55574H7.4Z'
        fill={color}
      />
      <path
        d='M7.4 8.46615H4V20H7.4V8.46615Z'
        fill={color}
      />
    </svg>
  );
}

export function OpenIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 5.75073C10.0196 5.75073 8.08376 6.33877 6.43794 7.4403C4.79701 8.53855 3.51806 10.0979 2.76211 11.9218C2.74531 11.9726 2.74531 12.0276 2.76211 12.0785C3.51806 13.9023 4.79701 15.4617 6.43794 16.5599C8.08376 17.6615 10.0196 18.2495 12 18.2495C13.9804 18.2495 15.9163 17.6615 17.5621 16.5599C19.203 15.4617 20.482 13.9023 21.2379 12.0785C21.2547 12.0276 21.2547 11.9726 21.2379 11.9217C20.482 10.0979 19.203 8.53855 17.5621 7.4403C15.9163 6.33877 13.9804 5.75073 12 5.75073Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 9.75012C10.7574 9.75012 9.75002 10.7575 9.75002 12.0001C9.75002 13.2428 10.7574 14.2501 12 14.2501C13.2427 14.2501 14.25 13.2428 14.25 12.0001C14.25 10.7575 13.2427 9.75012 12 9.75012Z'
        fill={color}
      />
    </svg>
  );
}

export function MoonIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.355 3.91566C9.31038 4.12823 8.3116 4.54232 7.41655 5.14038C6.05984 6.0469 5.00242 7.33537 4.378 8.84286C3.75358 10.3504 3.5902 12.0092 3.90853 13.6095C4.22685 15.2098 5.01259 16.6798 6.16637 17.8336C7.32016 18.9874 8.79017 19.7732 10.3905 20.0915C11.9909 20.4098 13.6497 20.2464 15.1571 19.622C16.6646 18.9976 17.9531 17.9402 18.8596 16.5835C19.4577 15.6884 19.8718 14.6896 20.0843 13.645C19.0056 14.2742 17.7703 14.614 16.5 14.614C14.6133 14.614 12.8038 13.8645 11.4697 12.5303C10.1355 11.1962 9.38604 9.38674 9.38604 7.5C9.38604 6.2297 9.7258 4.99442 10.355 3.91566Z'
        fill={color}
      />
    </svg>
  );
}

export function LoaderIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 17.5C15.0376 17.5 17.5 15.0376 17.5 12C17.5 8.96243 15.0376 6.5 12 6.5C8.96243 6.5 6.5 8.96243 6.5 12C6.5 15.0376 8.96243 17.5 12 17.5ZM19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12Z'
        fill={color}
      />
    </svg>
  );
}

export function NavigationIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V5C12.75 5.41421 12.4142 5.75 12 5.75C11.5858 5.75 11.25 5.41421 11.25 5V2C11.25 1.58579 11.5858 1.25 12 1.25Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 5.75C8.54822 5.75 5.75 8.54822 5.75 12C5.75 15.4518 8.54822 18.25 12 18.25C15.4518 18.25 18.25 15.4518 18.25 12C18.25 8.54822 15.4518 5.75 12 5.75Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 9.75C10.7574 9.75 9.75 10.7574 9.75 12C9.75 13.2426 10.7574 14.25 12 14.25C13.2426 14.25 14.25 13.2426 14.25 12C14.25 10.7574 13.2426 9.75 12 9.75Z'
        fill={color}
      />
    </svg>
  );
}

export function SearchIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11 3.75C6.99594 3.75 3.75 6.99594 3.75 11C3.75 15.0041 6.99594 18.25 11 18.25C15.0041 18.25 18.25 15.0041 18.25 11C18.25 6.99594 15.0041 3.75 11 3.75Z'
        stroke={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.1697 16.1697C16.4626 15.8768 16.9374 15.8768 17.2303 16.1697L21.5303 20.4697C21.8232 20.7626 21.8232 21.2374 21.5303 21.5303C21.2374 21.8232 20.7626 21.8232 20.4697 21.5303L16.1697 17.2303C15.8768 16.9374 15.8768 16.4626 16.1697 16.1697Z'
        fill={color}
      />
    </svg>
  );
}

export function SearchResultsIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.25 6C2.25 5.58579 2.58579 5.25 3 5.25H21C21.4142 5.25 21.75 5.58579 21.75 6C21.75 6.41421 21.4142 6.75 21 6.75H3C2.58579 6.75 2.25 6.41421 2.25 6Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17 12.75C15.7574 12.75 14.75 13.7574 14.75 15C14.75 16.2426 15.7574 17.25 17 17.25C18.2426 17.25 19.25 16.2426 19.25 15C19.25 13.7574 18.2426 12.75 17 12.75Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.5697 16.5697C18.8626 16.2768 19.3374 16.2768 19.6303 16.5697L21.5303 18.4697C21.8232 18.7626 21.8232 19.2374 21.5303 19.5303C21.2374 19.8232 20.7626 19.8232 20.4697 19.5303L18.5697 17.6303C18.2768 17.3374 18.2768 16.8626 18.5697 16.5697Z'
        fill={color}
      />
    </svg>
  );
}

export function RefreshIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.9972 2.25001L12 2.25C14.5859 2.25001 17.0658 3.27723 18.8943 5.10571C20.7228 6.93419 21.75 9.41414 21.75 12C21.75 12.4142 21.4142 12.75 21 12.75C20.5858 12.75 20.25 12.4142 20.25 12C20.25 9.81197 19.3808 7.71355 17.8336 6.16637C16.2868 4.61953 14.1889 3.75038 12.0014 3.75001C9.68149 3.7591 7.45475 4.66368 5.78576 6.2749L3.53033 8.53034C3.23744 8.82323 2.76256 8.82323 2.46967 8.53034C2.17678 8.23744 2.17678 7.76257 2.46967 7.46968L4.73864 5.2007C6.68676 3.3174 9.28759 2.2602 11.9972 2.25001Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 2.25001C3.41421 2.25001 3.75 2.58579 3.75 3.00001V7.25001H8C8.41421 7.25001 8.75 7.58579 8.75 8.00001C8.75 8.41422 8.41421 8.75001 8 8.75001H3C2.58579 8.75001 2.25 8.41422 2.25 8.00001V3.00001C2.25 2.58579 2.58579 2.25001 3 2.25001Z'
        fill={color}
      />
    </svg>
  );
}

export function OrderIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 1.25208C12.4821 1.25208 12.9557 1.37882 13.3734 1.61958L13.375 1.62051L20.375 5.6205C20.7926 5.86163 21.1395 6.20834 21.3809 6.62585C21.6222 7.04337 21.7495 7.51701 21.75 7.99926V16C21.7495 16.4823 21.6222 16.9567 21.3809 17.3742C21.1395 17.7917 20.7926 18.1384 20.375 18.3795L20.3721 18.3812L13.375 22.3795L13.3734 22.3805C12.9557 22.6212 12.4821 22.748 12 22.748C11.5179 22.748 11.0442 22.6212 10.6265 22.3804L10.625 22.3795L3.6279 18.3812L3.625 18.3795C3.20736 18.1384 2.86047 17.7917 2.61913 17.3742C2.3778 16.9567 2.2505 16.483 2.25 16.0008L2.25 8.00002C2.25049 7.51778 2.3778 7.04337 2.61913 6.62585C2.86047 6.20834 3.20736 5.86163 3.625 5.62051L3.62789 5.61884L10.6266 1.61961Z'
        fill={color}
      />
    </svg>
  );
}

export function SettingsIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.7544 9.50977C10.5144 9.50977 9.50439 10.5198 9.50439 11.7598C9.50439 12.9998 10.5144 14.0098 11.7544 14.0098C12.9944 14.0098 14.0044 12.9998 14.0044 11.7598C14.0044 10.5198 12.9944 9.50977 11.7544 9.50977ZM8.00439 11.7598C8.00439 9.68977 9.68439 8.00977 11.7544 8.00977C13.8244 8.00977 15.5044 9.68977 15.5044 11.7598C15.5044 13.8298 13.8244 15.5098 11.7544 15.5098C9.68439 15.5098 8.00439 13.8298 8.00439 11.7598Z'
        fill={color}
      />
    </svg>
  );
}

export function ProfileIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 3.75C9.65279 3.75 7.75 5.65279 7.75 8C7.75 10.3472 9.65279 12.25 12 12.25C14.3472 12.25 16.25 10.3472 16.25 8C16.25 5.65279 14.3472 3.75 12 3.75Z'
        stroke={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.81282 14.8128C7.45376 13.1719 9.67936 12.25 12 12.25C14.3206 12.25 16.5462 13.1719 18.1872 14.8128C19.8281 16.4538 20.75 18.6794 20.75 21C20.75 21.4142 20.4142 21.75 20 21.75C19.5858 21.75 19.25 21.4142 19.25 21C19.25 19.0772 18.4862 17.2331 17.1265 15.8735C15.7669 14.5138 13.9228 13.75 12 13.75C10.0772 13.75 8.23311 14.5138 6.87348 15.8735C5.51384 17.2331 4.75 19.0772 4.75 21C4.75 21.4142 4.41421 21.75 4 21.75C3.58579 21.75 3.25 21.4142 3.25 21C3.25 18.6794 4.17187 16.4538 5.81282 14.8128Z'
        fill={color}
      />
    </svg>
  );
}

export function OrganicIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.5255 1.36216C13.2375 1.1945 13.9808 1.21346 14.6834 1.41722C15.1601 1.55548 15.6071 1.77564 16.0051 2.06617C16.7212 1.55487 17.5837 1.27486 18.475 1.27486C19.0332 1.27486 19.5859 1.3848 20.1015 1.59839C20.6172 1.81198 21.0857 2.12504 21.4804 2.51971C21.875 2.91438 22.1881 3.38291 22.4017 3.89857C22.6153 4.41422 22.7252 4.9669 22.7252 5.52504C22.7252 6.08318 22.6153 6.63586 22.4017 7.15151C22.278 7.45019 22.1209 7.73306 21.9339 7.99492C22.2244 8.39298 22.4446 8.84001 22.5829 9.31673C22.7866 10.0193 22.8056 10.7626 22.6379 11.4746C22.4703 12.1867 22.1216 12.8434 21.6258 13.3812C21.3149 13.7185 20.9527 14.0019 20.5541 14.2218C20.7115 14.7201 20.7763 15.2456 20.7427 15.7718C20.6918 16.5704 20.4164 17.3385 19.9483 17.9875C19.4801 18.6366 18.8383 19.1403 18.0965 19.4406C17.5622 19.657 16.9918 19.7615 16.4201 19.7506C16.2198 20.2638 15.9312 20.7398 15.5657 21.1564C15.0544 21.7393 14.4082 22.1881 13.6835 22.4637C12.9589 22.7393 12.1777 22.8333 11.4084 22.7375C10.639 22.6418 9.90474 22.3591 9.26974 21.9143C9.24084 21.8941 9.2134 21.8718 9.18763 21.8477C8.30879 21.0254 7.15413 20.5629 5.95191 20.5503C4.78152 20.7264 4.00358 21.3526 2.95935 22.1932C2.80136 22.3204 2.63728 22.4525 2.46483 22.5887C2.16563 22.8249 1.73681 22.7991 1.46808 22.5287C1.19935 22.2583 1.17621 21.8294 1.4143 21.5316C1.50981 21.4122 1.60287 21.2968 1.6933 21.1847C2.60063 20.0596 3.2444 19.2613 3.45924 17.9828C3.53194 17.4902 3.41405 16.9773 3.14974 16.4142C2.88562 15.8515 2.50824 15.304 2.11045 14.7269L2.08752 14.6937L2.08733 14.6934C1.65082 14.0595 1.37488 13.329 1.28327 12.5648C1.19167 11.8006 1.28714 11.0256 1.56147 10.3064C1.8358 9.58731 2.28078 8.94562 2.85809 8.43659C3.27046 8.073 3.74152 7.78488 4.24956 7.58355C4.23813 7.01064 4.34265 6.43895 4.55944 5.90358C4.8598 5.16182 5.36349 4.51994 6.01255 4.0518C6.6616 3.58366 7.42964 3.30829 8.22828 3.25736C8.75451 3.22381 9.27994 3.28861 9.77833 3.44597C9.99823 3.04741 10.2816 2.6852 10.6188 2.37427C11.1567 1.87844 11.8134 1.52982 12.5255 1.36216Z'
        fill={color}
      />
    </svg>
  );
}

export function ReviewIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 1.25C12.2855 1.25 12.5462 1.41205 12.6726 1.66803L15.5882 7.57485L22.1085 8.52789C22.3909 8.56917 22.6254 8.76717 22.7135 9.03868C22.8015 9.31018 22.7278 9.60812 22.5233 9.80727L17.8059 14.402L18.9192 20.8932C18.9675 21.1746 18.8518 21.459 18.6208 21.6268C18.3898 21.7946 18.0836 21.8167 17.8309 21.6838L12 18.6174L6.16911 21.6838C5.91642 21.8167 5.6102 21.7946 5.37922 21.6268C5.14824 21.459 5.03255 21.1746 5.08082 20.8932L6.19413 14.402L1.47672 9.80727C1.27226 9.60812 1.19855 9.31018 1.28659 9.03868C1.37462 8.76717 1.60913 8.56917 1.89155 8.52789L8.41183 7.57485L11.3275 1.66803C11.4538 1.41205 11.7146 1.25 12 1.25Z'
        fill={color}
      />
    </svg>
  );
}

export function ReturnIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16 14.75C15.3096 14.75 14.75 15.3096 14.75 16V20C14.75 20.6904 15.3096 21.25 16 21.25H20C20.6904 21.25 21.25 20.6904 21.25 20V16C21.25 15.3096 20.6904 14.75 20 14.75H16Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4 2.75C3.30964 2.75 2.75 3.30964 2.75 4V8C2.75 8.69036 3.30964 9.25 4 9.25H8C8.69036 9.25 9.25 8.69036 9.25 8V4C9.25 3.30964 8.69036 2.75 8 2.75H4Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.25 7C13.25 6.58579 13.5858 6.25 14 6.25H15C15.7293 6.25 16.4288 6.53973 16.9445 7.05546C17.4603 7.57118 17.75 8.27065 17.75 9V10C17.75 10.4142 17.4142 10.75 17 10.75C16.5858 10.75 16.25 10.4142 16.25 10V9C16.25 8.66848 16.1183 8.35054 15.8839 8.11612C15.6495 7.8817 15.3315 7.75 15 7.75H14C13.5858 7.75 13.25 7.41421 13.25 7Z'
        fill={color}
      />
    </svg>
  );
}

export function PlusIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 4.25C12.4142 4.25 12.75 4.58579 12.75 5V11.25H19C19.4142 11.25 19.75 11.5858 19.75 12C19.75 12.4142 19.4142 12.75 19 12.75H12.75V19C12.75 19.4142 12.4142 19.75 12 19.75C11.5858 19.75 11.25 19.4142 11.25 19V12.75H5C4.58579 12.75 4.25 12.4142 4.25 12C4.25 11.5858 4.58579 11.25 5 11.25H11.25V5C11.25 4.58579 11.5858 4.25 12 4.25Z'
        fill={color}
      />
    </svg>
  );
}

export function TruckIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.05546 4.05546C2.57118 3.53973 3.27065 3.25 4 3.25H12C12.7293 3.25 13.4288 3.53973 13.9445 4.05546C14.4603 4.57118 14.75 5.27065 14.75 6V7.25H17.5211C17.7834 7.25037 18.0422 7.3097 18.2785 7.4236C18.5148 7.53749 18.7224 7.70304 18.8861 7.908L22.365 12.2567C22.6135 12.5664 22.7493 12.9515 22.75 13.3487V17C22.75 17.4641 22.5656 17.9092 22.2374 18.2374C21.9092 18.5656 21.4641 18.75 21 18.75H19C18.5858 18.75 18.25 18.4142 18.25 18C18.25 17.5858 18.5858 17.25 19 17.25H21V13.3513L17.7143 8.84452C17.691 8.81524 17.6609 8.79107 17.6271 8.7748C17.5935 8.75859 17.5567 8.75012 17.5194 8.75H14.75V17.25H15C15.4142 17.25 15.75 17.5858 15.75 18C15.75 18.4142 15.4142 18.75 15 18.75H9C8.58579 18.75 8.25 18.4142 8.25 18C8.25 17.5858 8.58579 17.25 9 17.25H13.25V6C13.25 5.66848 13.1183 5.35054 12.8839 5.11612C12.6495 4.8817 12.3315 4.75 12 4.75H4C3.66848 4.75 3.35054 4.8817 3.11612 5.11612C2.8817 5.35054 2.75 5.66848 2.75 6V17H5C5.41421 17.25 5.75 17.5858 5.75 18C5.75 18.4142 5.41421 18.75 5 18.75H3C2.53587 18.75 2.09075 18.5656 1.76256 18.2374C1.43437 17.9092 1.25 17.4641 1.25 17V6C1.25 5.27065 1.53973 4.57118 2.05546 4.05546Z'
        fill={color}
      />
    </svg>
  );
}

export function SparkIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.245 1.50387C11.4623 1.339 11.7276 1.24976 12.0004 1.24976C12.2732 1.24976 12.5385 1.339 12.7559 1.50387L13.2082 2.17784L14.7892 8.31266C14.845 8.52895 14.9577 8.72634 15.1157 8.88429C15.2736 9.0422 15.4709 9.15492 15.6871 9.21073L21.8344 10.7949C22.0981 10.8677 22.3307 11.025 22.4965 11.2427C22.6622 11.4604 22.752 11.7264 22.752 12C22.752 12.2736 22.6622 12.5396 22.4965 12.7573L21.8221 13.2084L15.6873 14.7892C15.471 14.845 15.2736 14.9578 15.1157 15.1157C14.9577 15.2737 14.845 15.4711 14.7892 15.6874L13.2072 21.8223C13.1297 22.0998 12.9722 22.3313 12.7549 22.4961C12.5375 22.661 12.2722 22.7503 11.9994 22.7503C11.7266 22.7503 11.4613 22.661 11.244 22.4961L10.7917 21.8222L9.21072 15.6874C9.1549 15.4711 9.04213 15.2736 8.88423 15.1157C8.72628 14.9578 8.52889 14.845 8.31259 14.7892L2.17767 13.2072C1.89848 13.1282 1.66818 12.9706 1.50418 12.7536C1.34019 12.5366 1.25146 12.272 1.25146 12C1.25146 11.728 1.34019 11.4634 1.50418 11.2464L2.17756 10.7928L8.31256 9.20979C8.52878 9.15404 8.72625 9.04136 8.8842 8.88353C9.04202 8.72581 9.15476 8.52873 9.2107 8.31273L10.7927 2.17773C10.8702 1.90018 11.0276 1.66873 11.245 1.50387Z'
        fill={color}
      />
    </svg>
  );
}

export function StarIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 1.25C12.2855 1.25 12.5462 1.41205 12.6726 1.66803L15.5882 7.57485L22.1085 8.52789C22.3909 8.56917 22.6254 8.76717 22.7135 9.03868C22.8015 9.31018 22.7278 9.60812 22.5233 9.80727L17.8059 14.402L18.9192 20.8932C18.9675 21.1746 18.8518 21.459 18.6208 21.6268C18.3898 21.7946 18.0836 21.8167 17.8309 21.6838L12 18.6174L6.16911 21.6838C5.91642 21.8167 5.6102 21.7946 5.37922 21.6268C5.14824 21.459 5.03255 21.1746 5.08082 20.8932L6.19413 14.402L1.47672 9.80727C1.27226 9.60812 1.19855 9.31018 1.28659 9.03868C1.37462 8.76717 1.60913 8.56917 1.89155 8.52789L8.41183 7.57485L11.3275 1.66803C11.4538 1.41205 11.7146 1.25 12 1.25Z'
        fill={color}
      />
    </svg>
  );
}

export function SwatchIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        d='M0.5 6.4C0.5 5.27164 0.500389 4.45545 0.552836 3.81352C0.604807 3.17744 0.705391 2.75662 0.881477 2.41103C1.21703 1.75247 1.75247 1.21703 2.41103 0.881477C2.75662 0.705391 3.17744 0.604807 3.81352 0.552836C4.45545 0.500389 5.27165 0.5 6.4 0.5H17.6C18.7284 0.5 19.5446 0.500389 20.1865 0.552836C20.8226 0.604807 21.2434 0.705391 21.589 0.881477C22.2475 1.21703 22.783 1.75247 23.1185 2.41103C23.2946 2.75662 23.3952 3.17744 23.4472 3.81352C23.4996 4.45545 23.5 5.27165 23.5 6.4V17.6C23.5 18.7284 23.4996 19.5446 23.4472 20.1865C23.3952 20.8226 23.2946 21.2434 23.1185 21.589C22.783 22.2475 22.2475 22.783 21.589 23.1185C21.2434 23.2946 20.8226 23.3952 20.1865 23.4472C19.5446 23.4996 18.7284 23.5 17.6 23.5H6.4C5.27164 23.5 4.45545 23.4996 3.81352 23.4472C3.17744 23.3952 2.75662 23.2946 2.41103 23.1185C1.75247 22.783 1.21703 22.2475 0.881477 21.589C0.705391 21.2434 0.604807 20.8226 0.552836 20.1865C0.500389 19.5446 0.5 18.7284 0.5 17.6V6.4Z'
        fill={color}
      />
    </svg>
  );
}

export function SunIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 8.75C10.2051 8.75 8.75 10.2051 8.75 12C8.75 13.7949 10.2051 15.25 12 15.25C13.7949 15.25 15.25 13.7949 15.25 12C15.25 10.2051 13.7949 8.75 12 8.75ZM7.25 12C7.25 9.37665 9.37665 7.25 12 7.25C14.6234 7.25 16.75 9.37665 16.75 12C16.75 14.6234 14.6234 16.75 12 16.75C9.37665 16.75 7.25 14.6234 7.25 12Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V4C12.75 4.41421 12.4142 4.75 12 4.75C11.5858 4.75 11.25 4.41421 11.25 4V2C11.25 1.58579 11.5858 1.25 12 1.25Z'
        fill={color}
      />
    </svg>
  );
}

export function SofaIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.05546 4.05546C4.57118 3.53973 5.27065 3.25 6 3.25H18C18.7293 3.25 19.4288 3.53973 19.9445 4.05546C20.4603 4.57118 20.75 5.27065 20.75 6V9C20.75 9.41421 20.4142 9.75 20 9.75C19.5858 9.75 19.25 9.41421 19.25 9V6C19.25 5.66848 19.1183 5.35054 18.8839 5.11612C18.6495 4.8817 18.3315 4.75 18 4.75H6C5.66848 4.75 5.35054 4.8817 5.11612 5.11612C4.8817 5.35054 4.75 5.66848 4.75 6V9C4.75 9.41421 4.41421 9.75 4 9.75C3.58579 9.75 3.25 9.41421 3.25 9V6C3.25 5.27065 3.53973 4.57118 4.05546 4.05546Z'
        fill={color}
      />
    </svg>
  );
}

export function TickThinIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.5607 7.4394C18.8536 7.73229 18.8536 8.20716 18.5607 8.50006L9.53035 17.5303C9.23746 17.8232 8.76259 17.8232 8.46969 17.5303L4.43945 13.5C4.14656 13.2071 4.14656 12.7322 4.43945 12.4393C4.73235 12.1464 5.20722 12.1464 5.50011 12.4393L9.00002 15.9393L17.5 7.4394C17.7929 7.1465 18.2678 7.1465 18.5607 7.4394Z'
        fill={color}
      />
    </svg>
  );
}

export function TimeIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 5.25C12.4142 5.25 12.75 5.58579 12.75 6V11.25H16.5C16.9142 11.25 17.25 11.5858 17.25 12C17.25 12.4142 16.9142 12.75 16.5 12.75H12C11.5858 12.75 11.25 12.4142 11.25 12V6C11.25 5.58579 11.5858 5.25 12 5.25Z'
        fill={color}
      />
    </svg>
  );
}

export function TickHeavyIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.8839 5.11612C21.372 5.60427 21.372 6.39573 20.8839 6.88388L9.88388 17.8839C9.39573 18.372 8.60427 18.372 8.11612 17.8839L3.11612 12.8839C2.62796 12.3957 2.62796 11.6043 3.11612 11.1161C3.60427 10.628 4.39573 10.628 4.88388 11.1161L9 15.2322L19.1161 5.11612C19.6043 4.62796 20.3957 4.62796 20.8839 5.11612Z'
        fill={color}
      />
    </svg>
  );
}

export function SortIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.46967 3.46967C6.76256 3.17678 7.23744 3.17678 7.53033 3.46967L11.5303 7.46967C11.8232 7.76256 11.8232 8.23744 11.5303 8.53033C11.2374 8.82322 10.7626 8.82322 10.4697 8.53033L7.75 5.81066V20C7.75 20.4142 7.41421 20.75 7 20.75C6.58579 20.75 6.25 20.4142 6.25 20V5.81066L3.53033 8.53033C3.23744 8.82322 2.76256 8.82322 2.46967 8.53033C2.17678 8.23744 2.17678 7.76256 2.46967 7.46967L6.46967 3.46967ZM17 3.25C17.4142 3.25 17.75 3.58579 17.75 4V18.1893L20.4697 15.4697C20.7626 15.1768 21.2374 15.1768 21.5303 15.4697C21.8232 15.7626 21.8232 16.2374 21.5303 16.5303L17.5303 20.5303C17.2374 20.8232 16.7626 20.8232 16.4697 20.5303L12.4697 16.5303C12.1768 16.2374 12.1768 15.7626 12.4697 15.4697C12.7626 15.1768 13.2374 15.1768 13.5303 15.4697L16.25 18.1893V4C16.25 3.58579 16.5858 3.25 17 3.25Z'
        fill={color}
      />
    </svg>
  );
}

export function YouTubeIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        d='M22.0001 11.9389C22.0095 10.3295 21.8722 8.7225 21.5901 7.13794C21.4653 6.71972 21.2332 6.34146 20.9169 6.04076C20.6006 5.74006 20.2111 5.5274 19.7871 5.42394C17.1952 5.12036 14.5865 4.98341 11.9771 5.01394C9.36806 4.98394 6.76006 5.12394 4.16906 5.43394C3.74844 5.54985 3.36511 5.77297 3.0566 6.08148C2.74809 6.38999 2.52496 6.77332 2.40906 7.19394C2.12706 8.77816 1.99049 10.3849 2.00106 11.9939C1.99106 13.6039 2.12806 15.2099 2.41006 16.7939C2.52799 17.2192 2.75386 17.6068 3.06574 17.919C3.37762 18.2312 3.76493 18.4575 4.19006 18.5759C6.78206 18.8789 9.39006 19.0159 12.0001 18.9849C14.6019 19.0201 17.2033 18.8832 19.7871 18.5749C20.2073 18.4591 20.5902 18.2362 20.8985 17.928C21.2068 17.6199 21.4299 17.2371 21.5461 16.8169C21.8531 15.2089 22.0061 13.5749 22.0001 11.9389ZM14.5891 12.5209L10.5841 14.7919C10.5034 14.8362 10.4126 14.8587 10.3206 14.8573C10.2286 14.8558 10.1386 14.8304 10.0594 14.7836C9.98017 14.7368 9.91451 14.6701 9.86887 14.5902C9.82322 14.5103 9.79917 14.4199 9.79906 14.3279V9.61594C9.79788 9.52361 9.82131 9.43264 9.86694 9.35236C9.91257 9.27209 9.97875 9.20541 10.0587 9.15919C10.1386 9.11296 10.2294 9.08885 10.3217 9.08933C10.4141 9.08982 10.5046 9.11488 10.5841 9.16194L14.7211 11.5399C14.8008 11.587 14.8665 11.6545 14.9115 11.7354C14.9564 11.8164 14.9789 11.9078 14.9767 12.0004C14.9744 12.093 14.9475 12.1832 14.8987 12.2619C14.8499 12.3406 14.781 12.4048 14.6991 12.4479L14.5891 12.5209Z'
        fill={color}
      />
    </svg>
  );
}

export function XIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        d='M13.5978 10.7136L19.8516 3.59998H18.3694L12.9406 9.77638L8.6026 3.59998H3.60003L10.159 12.9408L3.60003 20.4H5.08227L10.8161 13.8768L15.3975 20.4H20.4L13.5978 10.7136ZM5.61588 4.69198H7.89236L18.3706 19.3584H16.0941L5.61588 4.69198Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.5978 10.7136L20.4 20.4H15.3975L10.8161 13.8768L5.08227 20.4H3.60003L10.159 12.9408L3.60003 3.59998H8.6026L12.9406 9.77638L18.3694 3.59998H19.8516L13.5978 10.7136ZM12.9512 9.58261L8.66496 3.47998H3.36914L10.0065 12.9325L3.33472 20.52H5.13656L10.8055 14.0705L15.3351 20.52H20.6309L13.7502 10.7219L20.1169 3.47998H18.3151L12.9512 9.58261ZM16.1559 19.2384H18.1374L7.83061 4.81198H5.84911L16.1559 19.2384ZM16.0941 19.3584H18.3706L7.89236 4.69198H5.61588L16.0941 19.3584Z'
        fill={color}
      />
    </svg>
  );
}

export function MessageIcon({
  color = 'currentColor',
  size = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <path
        d='M13 8H7M17 12H7M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
